import { Component, OnInit, Inject } from "@angular/core";
import * as moment from "moment";
import { Router } from "@angular/router";
import { DateService } from "src/app/core";
import { Product } from "src/app/core/product/product.model";
import { AppService } from "src/app/core/app/app.service";
import { AddPassToDatePopupComponent } from "..";
import { Pass } from "src/app/core/product/product.factory";
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
  MAT_DIALOG_DATA
} from "@angular/material/dialog";
import { FormGroup } from "@angular/forms";
@Component({
  selector: "ll-date-details-popup",
  templateUrl: "./date-details-popup.component.html",
  styleUrls: ["./date-details-popup.component.scss"]
})
export class DateDetailsPopupComponent implements OnInit {
  public ds: DateService = new DateService();

  get products(): Product[] {
    return this.data.products;
  }
  get events(): Pass[] {
    return this.data.events;
  }
  get date(): string {
    return this.data.date;
  }
  constructor(
    public app: AppService,
    public router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<DateDetailsPopupComponent>
  ) {}

  ngOnInit(): void {
    this.showHiddenPasses = false;
  }

  get header(): string {
    return moment(this.date.replace("-", "/")).format("MMM DD, YYYY (ddd)");
  }

  get hasEvents(): boolean {
    return this.events.length != 0;
  }

  get isAdmin(): string {
    return this.router.url.includes("admin") ? "/admin" : "";
  }

  get hasProducts(): boolean {
    return this.applicable.length != 0;
  }

  public showHiddenPasses: boolean;

  get applicable(): Product[] {
    return this.products.reduce((list, product) => {
      const isActive = product.isActive || this.showHiddenPasses;
      const isNotAssignedToDate = !this.events.some(
        event => event.product.id == product.id
      );

      if (isActive && isNotAssignedToDate) list.push(product);
      return list;
    }, []);
  }

  addPass() {
    this.dialogRef.close();

    if (this.hasProducts) {
      const options = new MatDialogConfig();
      options.disableClose = false;
      options.autoFocus = true;
      options.width = "800px";
      options.height = "600px";
      options.hasBackdrop = true;
      options.ariaLabel = "Add Pass To Date Popup";
      options.data = {
        events: this.events,
        date: this.date,
        products: this.products
      };
      const dialogRef = this.dialog.open(AddPassToDatePopupComponent, options);
    } else {
      //Close Modal
      this.app.addProductBuilder();
      this.router.navigateByUrl(`${this.isAdmin}/venue/passes/pass-form`);
      //Navigate to Add New Pass Form
    }
  }
}
